import React from 'react';

const DEFAULT_FIELD = {
  name: '',
  type: 'input'
}

const Field = ({ field, onFieldAdd, onFieldChange, onFieldDelete }) => {
  const changeHandler = key => evt => {
    onFieldChange({
      ...field,
      [key]: evt.target.value
    })
  }
  return (
    <div className='form-group form-inline gap-2'>
      <input
        className='form-control'
        name='fields[][name]'
        onChange={changeHandler('name')}
        placeholder='Name of field'
        required
        type='text'
        value={field.name || ''}
      />
      <select
        className='form-control'
        onChange={changeHandler('type')}
        name='fields[][type]'
        value={field.type}
      >
        <option value='input'>Input</option>
        <option value='textarea'>Textarea</option>
      </select>

      {
        onFieldDelete && (
          <button
            className='btn btn-sm btn-outline-danger mb-1'
            onClick={onFieldDelete}
            type='button'
            title='Remove this field'
          >
            <i className='fa fa-minus'></i>
          </button>
        )
      }

      {
        onFieldAdd && (
          <button
            className='btn btn-sm btn-outline-success mb-1'
            onClick={onFieldAdd}
            title='Add another'
            type='button'
          >
            <i className='fa fa-plus'></i>
          </button>
        )
      }
    </div>
  )
}

export const FieldList = () => {
  const [fields, setFields] = React.useState([{...DEFAULT_FIELD}]);


  const replaceField = idx => replacement => setFields(
    prevFields => {
      const newFields = [...prevFields];
      newFields.splice(idx, 1, replacement);
      return newFields;
    }
  );

  const addField = () => setFields(
    prevFields => [...prevFields, {...DEFAULT_FIELD}]
  );

  const removeField = idx => setFields(
    prevFields => {
      const newFields = [...prevFields];
      newFields.splice(idx, 1);
      return newFields;
    }
  );

  return (
    <div>
      {
        fields.map(
          (f, idx) => (
            <Field
              key={idx}
              field={f}
              onFieldAdd={(idx === fields.length - 1) ? addField : undefined}
              onFieldChange={replaceField(idx)}
              onFieldDelete={idx !== 0 ? removeField : undefined}
            />
          )
        )
      }
    </div>
  )
}
